import { toNumber } from '@develop/ia-utils'

export const proceedToPharmacySwitchCheck = (pharmacyId: string) => {
  const parsedPharmacyId = toNumber(pharmacyId)

  if (parsedPharmacyId) {
    const pharmacySwitch = usePharmacySwitchStore()
    pharmacySwitch.fromPharmacyPage(parsedPharmacyId)
  }
}
